import { useApi } from '../api/useApi';
import { mediaUrl } from '../api/client';
import Loader from './ui/Loader';
import HeroVideo from './HeroVideo';

export default function Header() {
  const { data: settings, loading } = useApi('/settings', 'settings');
  const header = settings?.header;

  if (loading) {
    return (
      <section className="hero hero--loading" id="home">
        <Loader label="Cargando inicio..." />
      </section>
    );
  }

  const videoUrl = header?.video_url;
  const posterUrl = header?.image_url || '/assets/images/section-5.jpg';

  return (
    <section className="hero" id="home">
      <div className="hero__media">
        {videoUrl ? (
          <HeroVideo videoUrl={videoUrl} posterUrl={posterUrl} />
        ) : (
          <div
            className="hero__fallback"
            style={{ backgroundImage: `url(${mediaUrl(posterUrl)})` }}
            aria-hidden="true"
          />
        )}
        <div className="hero__overlay" />
      </div>

      <a href="#about" className="hero__scroll" aria-label="Ir a nosotros">
        <span />
      </a>
    </section>
  );
}
